module.exports = require("@splunk/dashboard-visualizations/Rectangle");